<template>
  <div id="app">
    <slide-transition :name="transitionName">
      <keep-alive include="StyleSelectMenu">
        <router-view />
      </keep-alive>
    </slide-transition>
  </div>
</template>

<script>
import 'sanitize.css'
import 'normalize.css'
import 'reset-css'
import 'swiper/dist/css/swiper.css'
import SlideTransition from '@/components/SlideTransition'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  components: {
    SlideTransition
  },
  data () {
    return {
      transitionName: ''
    }
  },
  computed: {
    ...mapGetters(['item', 'title'])
  }
}
</script>

<style>
#app {
  font-family: "Helvetica Neue",
    Arial,
    "Hiragino Kaku Gothic ProN",
    "Hiragino Sans",
    Meiryo,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
  height: 100vh;
}
body {
  /* padding-top: env(safe-area-inset-top);
  padding-right: env(safe-area-inset-right);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left); */
  /* margin: 0; */
  min-height: 100vh;
}
/* *, *::before, *::after {
  box-sizing: border-box;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue